export const isValidSpanishPostalCode = (value: string): boolean => {
  if (!/^[0-5][0-9]{4}$/.test(value)) {
    return false;
  }
  const province = parseInt(value.slice(0, 2), 10);
  return province >= 1 && province <= 52;
};
